/*
 * @Author: 孙培国
 * @Date: 2024-08-06 15:55:49
 * @LastEditors: Do not edit
 * @LastEditTime: 2024-08-29 09:26:09
 * @FilePath: \vue2-vant2-rem-h5-template\src\main.js
 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局引入按需引入UI库 vant
import '@/plugins/vant'
// 引入全局样式
import '@/assets/css/index.less'
// 移动端适配
import 'amfe-flexible'
// icon
import './assets/icons'

import {
  Swipe,
  SwipeItem,
  Step,
  Steps,
  Search,
  Field,
  Grid,
  GridItem,
  icon,
  Lazyload,
  NavBar,
  Divider,
  Picker,
  Popup,
  DatetimePicker,
  Toast,
  NoticeBar,
  Empty
} from 'vant'
Vue.use(Swipe)
  .use(SwipeItem)
  .use(Step)
  .use(Steps)
  .use(Search)
  .use(Field)
  .use(Grid)
  .use(GridItem)
  .use(Lazyload)
  .use(icon)
  .use(Divider)
  .use(NoticeBar)
  .use(Picker)
  .use(Popup)
  .use(DatetimePicker)
  .use(Toast)
  .use(Empty)
import { Row, Col, Tab, Tabs, List, Overlay, Uploader, Area, Cascader, PullRefresh, Tag, Image } from 'vant'
Vue.use(NavBar)
  .use(Row)
  .use(Col)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(Overlay)
  .use(Uploader)
  .use(Area)
  .use(Cascader)
  .use(PullRefresh)
  .use(Tag)
  .use(Image)
Vue.config.productionTip = false

// 日期格式化插件
import dayjs from 'dayjs'
Vue.prototype.$dayjs = dayjs
// 提示框封装
import { Tips } from '@/utils'
Vue.prototype.$tips = Tips

import Vconsole from 'vconsole'
// 开发环境使用，生产环境自动取消
if (process.env.NODE_ENV === 'staging') {
  new Vconsole()
}
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
